import useUser from '@alltrails/context/hooks/useUser';

// Only peak users have access to linking segments
const useCanLinkSegments = () => Boolean(useUser()?.featureEntitlements?.includes('build_your_own_trail'));

export default useCanLinkSegments;
